import { NgModule } from '@angular/core';
import { sessionStateServiceInjectionToken } from "./session/session-state-service-injection-token";
import { SessionStateService } from "./session/session-state.service";

@NgModule( {
  providers: [
    {
      provide: sessionStateServiceInjectionToken,
      useClass: SessionStateService
    }
  ],
} )
export class GlobalStatesModule {
}
